
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/companies/recommend",
      function () {
        return require("private-next-pages/companies/recommend/index.tsx");
      }
    ]);
  